import { Pressable, View, Text } from "react-native";
import { ResidentBedModel } from "app/services/api/types/locations/models/ResidentBedModel";
import { useRef, useState } from "react";
import { Icon, ThreeDotsIcon } from "ui/gluestack/icon";
import { ActionPopupMenu } from "../../../components/molecules/ActionPopupMenu";

interface Props {
  bed: ResidentBedModel & { startEditing?: boolean };
  roomId?: number;
  onEditBed: () => void;
  onDeleteBed: () => void;
}

export function EditableFormBedDetails({
  bed,
  roomId,
  onEditBed,
  onDeleteBed,
}: Props) {
  const [showMenu, setShowMenu] = useState(false);
  const menuIconRef = useRef<View>(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const openMenu = () => {
    menuIconRef.current?.measure((_fx, _fy, _width, height, px, py) => {
      setMenuPosition({ top: py + height, left: px });
      setShowMenu(true);
    });
  };

  const menuActions = [
    { title: "Edit bed details", onPress: onEditBed },
    { title: "Delete bed", onPress: onDeleteBed },
  ];

  return (
    <Pressable
      onLongPress={onEditBed}
      className="flex-1 flex-row py-4 pl-4 m-2 rounded-sm"
    >
      <View className="flex-1 mr-5">
        <View className="flex lg:flex-row justify-between gap-x-3 mb-3">
          <Text className="font-semibold">{bed.bed_number}</Text>
          <Text>{bed.description}</Text>
        </View>
      </View>

      <Pressable ref={menuIconRef} onPress={openMenu}>
        <Icon as={ThreeDotsIcon} className={"rotate-90"} />
      </Pressable>

      <ActionPopupMenu
        visible={showMenu}
        onClose={() => setShowMenu(false)}
        position={menuPosition}
        actions={menuActions}
      />
    </Pressable>
  );
}
